import React from "react";
import "./ButtonComponent.css";

const ButtonComponent = ({
  label,
  onClick,
  backgroundColor,
  color,
  disabled,
  href,
  target,
  icon,
}) => {
  const style = {
    backgroundColor,
    color,
  };

  const content = (
    <>
      {label}
      {icon}
    </>
  );

  if (href) {
    return (
      <a
        href={href}
        target={target}
        rel={target === "_blank" ? "noopener noreferrer" : undefined}
        style={style}
        className="button__style"
      >
        {content}
      </a>
    );
  }

  return (
    <button
      style={style}
      className="button__style"
      onClick={onClick}
      disabled={disabled}
    >
      {content}
    </button>
  );
};

export default ButtonComponent;